import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider, useApp } from "./context/AppContext";
import RoleSelection from "./pages/RoleSelection";
import ElemanEntry from "./pages/ElemanEntry";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import BankManagement from "./pages/BankManagement";
import CreditManagement from "./pages/CreditManagement";
import KrediKartlari from "./pages/KrediKartlari";
import LC from "./pages/LC";
import Cekler from "./pages/Cekler";
import DigerOdemeler from "./pages/DigerOdemeler";
import TumOdemeler from "./pages/TumOdemeler";
import Faturalar from "./pages/Faturalar";
import Siparisler from "./pages/Siparisler";
import GiderGelir from "./pages/GiderGelir";
import MobileHome from "./pages/MobileHome";
import Trendyol from "./pages/Trendyol";
import FaturalarDashboard from "./pages/FaturalarDashboard";
import Layout from "./components/Layout";
import { Toaster } from "./components/ui/sonner";

function AppRoutes() {
  const { currentUser } = useApp();

  if (!currentUser) {
    return <RoleSelection />;
  }

  // veri_giris rolü sadece veri girişi yapabilir
  if (currentUser.rol === "veri_giris" || currentUser.rol === "eleman") {
    return (
      <Layout>
        <ElemanEntry />
      </Layout>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/menu" element={<MobileHome />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/raporlar" element={<Reports />} />
        <Route path="/cekler" element={<Cekler />} />
        <Route path="/diger-odemeler" element={<DigerOdemeler />} />
        <Route path="/tum-odemeler" element={<TumOdemeler />} />
        <Route path="/bankalar" element={<BankManagement />} />
        <Route path="/krediler" element={<CreditManagement />} />
        <Route path="/kredi-kartlari" element={<KrediKartlari />} />
        <Route path="/lc" element={<LC />} />
        <Route path="/faturalar-dashboard" element={<FaturalarDashboard />} />
        <Route path="/faturalar" element={<Faturalar />} />
        <Route path="/siparisler" element={<Siparisler />} />
        <Route path="/gider-gelir" element={<GiderGelir />} />
        <Route path="/trendyol" element={<Trendyol />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppProvider>
          <AppRoutes />
          <Toaster />
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;